export enum Panel {
  None,
  Filters,
  Actions
}
